import './src/main.css'
import Loading from './src/main.vue'

export default function (Vue) {
  Vue.component(Loading.name, Loading)
}



// WEBPACK FOOTER //
// ./~/@jiaminghi/data-view/lib/components/loading/index.js